import moment from "../../../../plugins/moment";
import { mapGetters } from "vuex";
import { NIGHTS_GET_IS_PACK_FLIGHT } from "../../../../store/nights/getter-types";

export default {
    props: {
        flightDetails: {
            type: Object,
            required: true
        },
        finalPrice: {
            type: Number,
            required: true
        },
        extraNoPromoPercentage: {
            type: Number,
            required: false,
            default: 0
        },
        totalPassengers: {
            type: Number,
            required: true
        },
        showPartialPayment: {
          type: Boolean,
          default: false
        },
        itinerary: {
          default: 1
        }
    },
    computed: {
        totalPriceNoPromo() {
            return Number(this.finalPrice) / (1 - this.extraNoPromoPercentage / 100);
        },
        ...mapGetters({
            isPackFlight: NIGHTS_GET_IS_PACK_FLIGHT,
        }),
        passengerPrice() {
            return (this.finalPrice / this.totalPassengers).toFixed(2);
        },
        passengersText() {
        if (this.totalPassengers === 1) {
                return `${this.totalPassengers} ${this.$t('shared.passenger')}`;
            } else {
                return `${this.totalPassengers} ${this.$t('shared.passengers')}`;
            }
        },
        travelDates() {
        const departureTime = moment(this.$route.query.start);
        const arrivalTime = moment(this.$route.query.end);

            if (departureTime.isSame(arrivalTime, 'month')) {
                return `${departureTime.format('D')} - ${arrivalTime.format('D MMMM YYYY')}`;
            } else {
                return `${departureTime.format('D MMMM')} - ${arrivalTime.format('D MMMM YYYY')}`;
            }
        },
        sixtyPercent() {
            return this.calculatePercentage(60).toFixed(2);
        },
        fortyPercent() {
            return this.calculatePercentage(40).toFixed(2);
        },
        numDays(){
          return this.flightDetails.returnFlightDepartureTime && this.flightDetails.returnFlightArrivalTime.diff(this.flightDetails.journeyFlightDepartureTime, 'days');
        },
        flight() {
          return this.$store.state.nights.flight;
        },
    },
    methods: {
        calculatePercentage(percentage) {
            const total = this.finalPrice;
            const result = (percentage / 100) * total;
            return result;
        },
    }
};

